import { createContext } from 'react';

var Theme;
(function (Theme) {
  Theme["light"] = "light";
  Theme["dark"] = "dark";
  Theme["auto"] = "auto";
})(Theme || (Theme = {}));
var ThemeContext = /*#__PURE__*/createContext({
  theme: Theme.auto
});

export { Theme, ThemeContext };
